import { observer } from 'mobx-react-lite';

import { Toast as ToastModel } from '@/types/models/toasts';

import { Toast } from './Toast';

type ToastContainerProps = {
  toasts: ToastModel[];
  removeToast: (id: number) => void;
};

export const ToastContainer = observer<ToastContainerProps>(
  ({ toasts, removeToast }) => (
    <div>
      {toasts.map((toast) => (
        <Toast
          type={toast.type}
          key={toast.id}
          id={toast.id}
          message={toast.message}
          icon={toast.icon}
          duration={toast.duration}
          onClose={removeToast}
        />
      ))}
    </div>
  ),
);
